import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import { invalidateCandidateAvatarQueries } from "./invalidateCandidateAvatarQueries";

interface CandidateUpdate {
  uuid: string;
  photo_url?: string | null;
  [key: string]: unknown;
}

export default function useMutateCandidate() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: (candidate: CandidateUpdate) => {
      return axios.patch(`/candidate/${candidate.uuid}`, candidate);
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.uuid], data);

      if (Object.prototype.hasOwnProperty.call(variables, "photo_url")) {
        return invalidateCandidateAvatarQueries(client);
      }
    },
  });
}
